import { camelCase } from 'lodash-es';
import { CustomDomainDashboardData } from '../../model/custom-domain-dashboard-data';

// This function will get all data attributes from the app-root element and return them as an object.
export function getDataAttributesFromAppRoot(): CustomDomainDashboardData {
  const appRoot = document.querySelector('app-root');

  if (!appRoot) {
    throw new Error('Could not find app-root element.');
  }

  const dataAttributes = appRoot.getAttributeNames().filter((a) => a.startsWith('data-'));
  const dataObject: { [key: string]: string } = {};

  dataAttributes.forEach((attribute) => {
    const attributeName = attribute.replace('data-', '');
    const attributeValue = appRoot.getAttribute(attribute)?.replace(/\{\{\w*\}\}/, ''); // treat handlebars placeholders as empty strings
    if (!!attributeValue) {
      dataObject[camelCase(attributeName)] = attributeValue;
    }
  });

  return <CustomDomainDashboardData>dataObject;
}
